import type { OrgAccess } from "./types";

/** Decode a JWT's payload without verifying it (the server does that). */
export function decodeJwtClaims(token: string | null | undefined): Record<string, unknown> | null {
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    const payload = JSON.parse(json);
    return payload && typeof payload === "object" ? (payload as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

/**
 * The access token's `org_access` claim. People stamps it on every access
 * token; anything missing or unrecognised reads as "full" (an older token,
 * or a deployment before the claim existed, must not lock anybody out).
 */
export function readOrgAccess(token: string | null | undefined): OrgAccess {
  return decodeJwtClaims(token)?.org_access === "billing_only" ? "billing_only" : "full";
}
